<template>
  <div :class="$style.content">
    <img :src="icon">
  </div>
</template>

<script>
export default {
  name: 'author',
  props: {
    icon: String,
    name: String,
  },
}
</script>

<style scoped lang="scss" module>
.content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  img {
    max-width: 100%;
  }
  @media (max-width: $tabletWidth) {
    width: 5rem;
  }
  @media (max-width: $mobileWidth) {
    width: 6rem;
  }
}
span {
  position: absolute;
  bottom: 2px;
  left: 50%;
  width: 100%;
  transform: translateX(-50%);
  font-size: 1.2rem;
  line-height: 16px;
  padding: 2px 5px;
  background: $white;
  //border-radius: 10px;
  white-space: nowrap;
}
</style>
